/**
 * withLinks Plugin
 * Configures the editor to treat links as inline elements
 */
import { Editor } from 'slate';

const withLinks = (editor: Editor) => {
  const { isInline } = editor;

  // Links are inline elements
  editor.isInline = (element) => {
    return element.type === 'link' ? true : isInline(element);
  };

  return editor;
};

export default withLinks;
